import type { Dtos } from "@inrev/common";
import { Card, Text } from "@portal/components/primitives";
import { NAICSCodesList } from "../../admin/shared/NAICSCodeList";
import { AdminDataList, type AdminDataListProps } from "../../shared/admin/AdminDataList";

type AgentBondDetailsBond = Pick<Dtos.SuretyBond.Get.Response, "scopeOfWork">;

export type AgentBondDetailsCardProps = {
	bond: AgentBondDetailsBond;
};

export const AgentBondDetailsCard = ({ bond }: AgentBondDetailsCardProps) => {
	const rows: AdminDataListProps["data"] = [
		{
			label: "Scope of Work",
			value: (
				<NAICSCodesList
					naicsCodes={bond.scopeOfWork}
					showRatio
					emptyMessage="Unavailable"
					className="min-w-[400px] max-w-[400px]"
				/>
			),
		},
	];

	return (
		<Card elevation="raised" className="rounded-xl" data-testid="agent-bond-details-card">
			<Card.Body className="p-6">
				<div className="flex w-full flex-col space-y-5">
					<Text type="title" color="primary">
						Bond Details
					</Text>
					<div className="flex flex-col divide-y divide-bc-default">
						<AdminDataList bare data={rows} />
					</div>
				</div>
			</Card.Body>
		</Card>
	);
};
